import React from 'react';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

export const wholeStyles: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '10px'
};

export const columnsAutocompleteStyles = (blocks: any): SxProps<Theme> => {
  return {
    width: blocks.length > 1 ? '225px' : '250px',
    minHeight: '40px',
    '& .MuiChip-root': {
      backgroundColor: 'rgb(250,250,250)',
      color: 'black !important',
      // border: '1px solid #D9D9D9',
      fontFamily: 'Circular Std Book !important'
    },
    '& .MuiChip-label': {
      fontFamily: 'Circular Std Book !important'
    },
    '& .MuiChip-deleteIcon': {
      fontSize: '16px', // Adjust the size to your preference
      width: '16px',
      height: '16px'
    },
    '& .MuiOutlinedInput-root': {
      padding: '0px',
      minHeight: '40px',
      border: '.5px solid #D9D9D9',
      borderRadius: '4px',

      '&:hover': {
        borderColor: '#D9D9D9'
      },
      '&.Mui-focused': {
        borderColor: '#D9D9D9'
      },
      '& fieldset': {
        border: 'none'
      }
    },
    // '& .MuiSvgIcon-root': {
    //   width: '24px',
    //   height: '24px',
    // },
    '& .MuiAutocomplete-listbox': {
      fontFamily: 'Circular Std Book !important'
    },
    '& .MuiInputBase-input': {
      fontSize: '14px'
    }
  };
};

export const columnsAutocompleteLiStyles: React.CSSProperties = {
  fontFamily: 'Circular Std Book',
  fontSize: '12px',
  color: '#777777',
  fontWeight: 450
};

export const columnsAutocompletePlaceholderStyles: SxProps<Theme> = {
  '& .MuiInputBase-input::placeholder': {
    fontSize: '14px',
    fontFamily: 'Circular Std Book',
    color: '#777777',
    fontWeight: 450
  }
};

export const removeIconStyles = (blockIndex: number): React.CSSProperties => {
  return {
    color: 'red',
    marginTop: blockIndex === 1 ? '17px' : 0,
    padding: '0'
    // zIndex: '999999999'
  };
};
